import type { JobOut } from "./types";

export const isClosedJob = (job: Pick<JobOut, "status">) => ["completed", "invoiced", "cancelled"].includes(job.status);
export const JOB_VIEWS = [
  { key: "open", label: "Active" },
  { key: "unbooked", label: "Needs booking" },
  { key: "upcoming", label: "Upcoming" },
  { key: "history", label: "History" },
  { key: "billing", label: "Ready to invoice" },
  { key: "risk", label: "Losing money" },
  { key: "all", label: "Everything" },
];

export function jobsForView(jobs: JobOut[], view: string, search: string, now = Date.now()): JobOut[] {
  const needle = search.trim().toLowerCase();
  return jobs.filter(job => {
    if (needle && !`${job.number} ${job.title}`.toLowerCase().includes(needle)) return false;
    switch (view) {
      case "open": return !isClosedJob(job);
      case "unbooked": return !isClosedJob(job) && !job.scheduled_start && !["on_site", "in_progress"].includes(job.status);
      case "upcoming": return !isClosedJob(job) && !!job.scheduled_start && Date.parse(job.scheduled_end ?? job.scheduled_start) >= now;
      case "history": return isClosedJob(job);
      case "billing": return job.status === "completed";
      case "risk": return !isClosedJob(job) && job.revenue_cents > 0 && job.margin_bp < 3100;
      default: return true;
    }
  }).sort((a, b) => view === "upcoming"
    ? Date.parse(a.scheduled_start!) - Date.parse(b.scheduled_start!) || a.number.localeCompare(b.number)
    : 0);
}

export function bookingLabel(job: Pick<JobOut, "scheduled_start">): string {
  return job.scheduled_start ? new Intl.DateTimeFormat("en-AU", {
    dateStyle: "medium", timeStyle: "short",
  }).format(new Date(job.scheduled_start)) : "Not booked";
}
